import React, {Component} from "react";
import {connect} from 'react-redux';
import {
    Box,
    Button,
    CircularProgress,
    Grid,
    IconButton,
    Stack,
    Typography
} from "@mui/material";
import {getAnnotationAppLayer, getDeepBioAppDrawerLayer} from "../utils/layers_info";
import RefreshIcon from '@mui/icons-material/Refresh';
import {getAnnotationFromPoints, getAnnotationFeature} from "../utils/annotations_app_utils";
import {polygonDrawingKey} from "../drawer/draw_tool_keys";
import VectorSource from "ol/source/Vector";
import axios from "axios";
import {message} from "antd";
import {Fill, Stroke, Style, Text as OlText} from "ol/style.js";
import {AnnotationsConstants, DeepBioConstants} from "../../../utils/const";
import {Tooltip} from "@mui/material";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import {updateDeepBioDisplayColor, updateDeepBioResultsDisplayed} from "../../../action/deepbio.action";
import {updateActiveAnnoDrawer} from "../../../action/gamma.state.action";
import {retrieveAnnotations} from "../../../action/maps.state.action";
import AnnotationsExpandableList from "./AnnotationsExpandableList";
import {getEyeCheckbox} from "../components/components";
import {getDeepBioResultComponent, runDeepBioAI} from "../utils/deepBioAppUtils";
import {Biotech, VisibilityOff} from "@mui/icons-material";
import {locateAnnotationOnMap} from "../utils/map_utils";

class DeepBioApp extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetching: false,
            selectedAnnoMap: "",
            slide_uploaded: true,
            whole_slide_ai_run: 2,
            running_status_whole_slide: "",
            deep_bio_results_visible: [],
            unlock: false,
            status: "",
            upload_not_started: false,
            whole_slide_ai_obj: null,
            uploaded: false,
            upload_status: "",
            whole_slide_ai_status: "NOT_RUN",
            whole_slide_ai_result: {},
            whole_slide_ai_progress: 0,
            showing_whole_slide_results: false,
            selected_annos: [],
            annos_in_queue:{},
        }
        this.timer = null;
    }

    initState = () => {
        this.activeMapId = this.props.activeMapId;
        this.mapState = this.props.mapsState[this.activeMapId];
        this.slideState = this.mapState.slideState;
        this.annotationState = this.mapState.annotationState;
        this.deepBioState = this.mapState.deepBioState;
    }

    getSlideUploadStatus = () => {
        this.setState({
            fetching: true,
        })
        let url = `/api/get_deep_bio_upload_stage/?id=${this.slideState.slide_data.id}`
        axios.get(url).then(res => {
            let uploaded = res.data['uploaded']
            if(uploaded !== 1){
                this.setState({
                    uploaded: uploaded,
                })
            }else{
                this.setState({
                    uploaded: uploaded,
                    upload_status: res.data['status'],
                })
            }
        })
    }

    compareArrays = (array1, array2) => {
        if (array1.length === array2.length){
            for(let i=0;i<array1.length;i++){
                if(array1[i] !== array2[i]){
                    return false;
                }
            }
            return true;
        }
        else
            return false
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.deepBioData !== this.props.deepBioData)
            this.updateDeepBioResultsDisplayed();
    }

    updateDeepBioResultsDisplayed = () => {
        let selected = this.props.deepBioData.ai_results_displayed;
        let vector = this.deepBioState.resultVector;
        let annotations_list = this.deepBioAnnotations;
        let filter = this.props.deepBioData.active_filter;
        let features = [];
        for(let i=0; i<selected.length; i++)
            if(selected[i] === "ALL") {
                let contours = ((this.state.whole_slide_ai_result||{})['heatmap']||{})['contours']
                if (!contours) return;
                for(let i=0;i<contours.length;i++)
                    if (filter === "ALL" || filter.toLowerCase() === contours[i].color.toLowerCase()) {
                        let color = contours[i]['color'];
                        let bounds = contours[i]['contour'];
                        let new_anno = getAnnotationFromPoints(
                            color, 0, 0, polygonDrawingKey, bounds, [0,0], 2, 0,
                            this.slideState.slide_data.id
                        )
                        new_anno.title = contours[i]['label']
                        let new_anno_feature = getAnnotationFeature(new_anno);
                        new_anno_feature.set('parent_anno', "ALL");
                        features.push(new_anno_feature);
                    }
            } else
                for(let j=0;j<annotations_list.length; j++)
                    if(annotations_list[j].id === selected[i]) {
                        let annotation = annotations_list[j];
                        let contours = ((annotation['result']||{})['heatmap']||{})['contours'];
                        if(!contours) continue;
                        for(let i=0; i<contours.length; i++)
                            if (filter === "ALL" || filter.toLowerCase() === contours[i].color.toLowerCase()) {
                                let color = contours[i]['color'];
                                let bounds = contours[i]['contour'];
                                let new_anno = getAnnotationFromPoints(
                                    color, 0, 0, polygonDrawingKey, bounds, [0,0], 2, 0,
                                    this.slideState.slide_data.id
                                )
                                new_anno.title = contours[i]['label']
                                let new_anno_feature = getAnnotationFeature(new_anno);
                                new_anno_feature.set('parent_anno', annotations_list[j].id);
                                features.push(new_anno_feature);
                            }
                    }
        vector.setSource(
            new VectorSource({
                features: features,
                wrapX: false,
            })
        )
        vector.setStyle(this.styleFunctionDeepBio);
    }

    getWholeSlideAIStatus = () => {
        let url = `/api/get_deep_bio_whole_slide_run_status/?id=${this.slideState.slide_data.id}`
        axios.get(url).then(res=>{
            let result = res.data['result']
            let status = res.data['status']
            let progress = res.data['progress']
            this.setState({
                whole_slide_ai_status:status,
                whole_slide_ai_result:result,
                whole_slide_ai_progress:progress,
            })
        }).catch(err=>{
            console.log("error--", err)
        })
    }

    componentDidMount() {
        // here we get the status of the slide i.e in what state the slide currently is
        // assume its uploaded
        // in our backend api before returning whether slide is already present or not we will check time too and return accordingly no uploading afterwards

        this.getSlideUploadStatus();
        this.getWholeSlideAIStatus();
        //change anno drawer on mounting only
        let deepBioAppLayer = getDeepBioAppDrawerLayer(this.props.gammaState);
        let deepBioAppDrawer = deepBioAppLayer.anno_drawer;
        this.props.dispatch(updateActiveAnnoDrawer(deepBioAppDrawer))
        // this.timer = setInterval(this.refreshData, 10000);
    }

    componentWillUnmount() {
        let annoAppLayer = getAnnotationAppLayer(this.props.gammaState);
        let annoAppDrawer = annoAppLayer.anno_drawer;
        this.props.dispatch(updateActiveAnnoDrawer(annoAppDrawer))
    }

    baseStyle = new Style({
            stroke: new Stroke({
            color: 'rgba(255, 0, 0, 0.0)',
            width: 2
        }),
        fill: new Fill({
            color: 'rgba(255, 0, 0, 0.0)'
        })
    });

    baseText = new OlText({
            font: 'bold 20px "Open Sans", "Helvetica", "sans-serif"',
            placement: AnnotationsConstants.LINE,
            textBaseline: 'top',
            fill: new Fill({
                color: "#00FF00"
            }),
            backgroundFill: new Fill({
                    color: "#ffffff"
            }),
            backgroundStroke: new Fill({
                    color: "#ffffff"
            })
})

    selectedStyle = new Style({
            stroke: new Stroke({
            color: "#00b3ff",
            width: 8
        })
    })

    otherStyle = new Style({
            stroke: new Stroke({
            color: "white",
            width: 0
        })
    })

    hexToRGBA = (hex, opacity=0.2) => {
        return 'rgba(' + (hex = hex.replace('#', '')).match(new RegExp('(.{' + hex.length/3 + '})', 'g')).map(function(l) { return parseInt(hex.length%2 ? l+l : l, 16) }).concat(isFinite(opacity) ? opacity : 1).join(',') + ')';
    }

    styleFunctionDeepBio = feature => {
        let baseStyleWithText = this.baseStyle;
        let baseText = this.baseText;
        this.baseText.setText(feature.get('title'));
        if(feature.getProperties().color) {
            baseStyleWithText.getStroke().setColor(feature.getProperties().color);
            baseText.getFill().setColor(feature.getProperties().color);
            baseStyleWithText.getFill().setColor(this.hexToRGBA(feature.getProperties().color))
            // baseStyleWithText.getFill().getColor().setOpacity(0.2)
        }
        baseStyleWithText.setText(baseText);
        if(feature.getProperties().selected) {
            return [this.selectedStyle, baseStyleWithText]
        }else{
            return [this.otherStyle, baseStyleWithText]
        }
    }

    removeAnnoFromQueue = (annos) => {
        let annos_in_queue = this.state.annos_in_queue;
        for(let i=0;i<annos.length;i++){
            let anno=annos[i];
            annos_in_queue[anno] = false;
        }
        this.setState({
            annos_in_queue: annos_in_queue,
            selected_annos:[],
        })
        this.props.dispatch(retrieveAnnotations(this.activeMapId, this.slideState.slide_data.id))
    }


    runAIOnSelectedAnnotations = (selected_anno_ids) => {
        if(this.state.uploaded !== 2){
            message.info("Please Upload Slide First")
            return;
        }
        let slide = this.slideState.slide_data;
        if (selected_anno_ids.includes("ALL"))
            return runDeepBioAI(slide.morphle_id, slide.id, [], this.getWholeSlideAIStatus);
        let annos_in_queue = this.state.annos_in_queue;
        for (let i=0; i<selected_anno_ids; ++i) {
            annos_in_queue[selected_anno_ids[i]]=true;
        }
        this.setState({
            annos_in_queue: annos_in_queue,
        });
        runDeepBioAI(slide.morphle_id, slide.id, selected_anno_ids,
            () => this.removeAnnoFromQueue(selected_anno_ids));
    }

    getMultipleSelectComponent = (selectedId) => {
        let selected_anno_ids = []
        for (const [key, value] of Object.entries(selectedId)) {
            if(value === true){
                selected_anno_ids.push(key)
            }
        }
        console.log("slide-x-after",selected_anno_ids)
        return <Grid sx={{height:'3vh'}}>
                    <Tooltip title={"Run AI on Selected"} placement={"right"}>
                    <IconButton onClick={(e)=>(this.runAIOnSelectedAnnotations(e, selected_anno_ids))}
                                color={"secondary"}><PlayArrowIcon/></IconButton>
                    </Tooltip>
                </Grid>
    }

    getTopComponent = () =>
        <Stack direction={"row"} justifyContent={"space-between"}>
            {this.state.uploaded === 0 ?
                <Button variant={"contained"} color={"secondary"} onClick={this.uploadSlide}>
                    UPLOAD SLIDE</Button> :
                <Button sx={{width:'98%', backgroundColor:"rgba(108,122,137,1)!important",
                    color:'rgba(255,255,255,1) !important'}} disabled>
                    {this.state.uploaded === 1 ? this.state.upload_status : "Upload Completed"}
                </Button>
            }
            <IconButton onClick={this.onRefreshApp} color={"secondary"}><RefreshIcon/></IconButton>
        </Stack>

    uploadSlide = () => {
        let slideId = this.slideState.slide_data.id;
        let url = `/api/deepbio_upload/?id=${slideId}`
        axios.get(url).then(() => {
            message.info("Slide Upload Started")
            this.getSlideUploadStatus();
        })
    }

    onRefreshApp = () => {
        this.getSlideUploadStatus();
        this.props.dispatch(retrieveAnnotations(this.activeMapId, this.slideState.slide_data.id));
        this.getWholeSlideAIStatus();
    }

    onEyeCheckbox = (annotation, checked) => {
        if (checked)
            this.props.dispatch(updateDeepBioResultsDisplayed([annotation.id,
                ...this.props.deepBioData.ai_results_displayed.filter(id => id !== annotation.id)]));
        else this.props.dispatch(updateDeepBioResultsDisplayed(
            [...this.props.deepBioData.ai_results_displayed.filter(id => id !== annotation.id)]));
    }

    getDeepBioAnnotationAction = (annotation) => {
        let deepBioResult = (annotation.deep_bio_result || [])[0];
        return deepBioResult && deepBioResult['fields'] &&  deepBioResult['fields']['status'] !== 'NOT_RUN'?
            deepBioResult['fields']['status'] === 'FINISHED' ?
                getEyeCheckbox(undefined, false,
                    e => this.onEyeCheckbox(annotation, e.target.checked), <VisibilityOff />) :
                <Tooltip title={deepBioResult['fields']['status']} placement="top-start">
                    <Box sx={{ position: 'relative', display: 'inline-flex', marginLeft:"-14px" }}>
                        <CircularProgress variant="determinate" value={deepBioResult['fields']['progress']}
                                          color={"secondary"} />
                        <Box
                            sx={{
                                top: 0,
                                left: 0,
                                bottom: 0,
                                right: 0,
                                position: 'absolute',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}
                        >
                            <Typography variant="caption" component="div" color="text.secondary">
                                {`${Math.round(deepBioResult['fields']['progress'])}%`}
                            </Typography>
                        </Box>
                    </Box>
                </Tooltip> :
            <Tooltip title={this.state.uploaded === 2 ? "Run AI" : this.state.uploaded === 1 ?
                "Waiting for slide to upload" : "Upload Slide to Run AI"} placement={"bottom"}>
                <IconButton onClick={()=>(this.runAIOnSelectedAnnotations([annotation.id]))}
                            disabled={this.state.uploaded !== 2}
                            color={"secondary"}><PlayArrowIcon/></IconButton>
            </Tooltip>
    }

    render() {
        this.initState();
        if (!this.deepBioState) return <div />;

        this.deepBioAnnotations = this.annotationState.annotations.filter(annotation => annotation.anno_drawer === 1);

        let annotations = [{
            id: "ALL",
            title: "Whole Slide",
            icon: <Biotech />,
            result: this.state.whole_slide_ai_result,
            deep_bio_result: [{
                fields: {
                    status: this.state.whole_slide_ai_status,
                    progress: this.state.whole_slide_ai_progress,
                }
            }],
            color: "ALL",
            onlyShowResult: true,
        }, ...this.deepBioAnnotations];

        annotations.forEach(annotation => {
            annotation.actionComponent = this.getDeepBioAnnotationAction(annotation);
            annotation.resultComponent = getDeepBioResultComponent((annotation.result || {}).summary);
        });

        let annotationsComponent = <AnnotationsExpandableList annotations={annotations}
                                                              slideId={this.slideState.slide_data.id}
                                                              colors={DeepBioConstants.LABELS}
                                                              showColorLabels={true}
                                                              actionOnSelected={this.runAIOnSelectedAnnotations}
                                                              actionTooltip={"Run AI on selected Annotations"}
                                                              onColorFilter={color =>
                                                                  this.props.dispatch(updateDeepBioDisplayColor(color))}
                                                              onAnnotationClick={(annotation) =>
                                                                  locateAnnotationOnMap(this.slideState.slidemap,
                                                                      annotation)}
        />

        return <Stack direction={"column"} spacing={1}>
            {this.getTopComponent()}
            {annotationsComponent}
        </Stack>
    }
}

const mapStateToProps = (state) => {
    return {
        gammaState: state.gammaStateReducer,
        activeMapId: state.gammaStateReducer.activeMapId,
        mapsState: state.mapsStateReducer,
        triggerData: state.triggerReducer,
        deepBioData: state.deepBioReducer,
    }
}

export default connect(mapStateToProps)(DeepBioApp);
